import React, { useContext } from "react";
// import images
import MyImg from "../img/home/image1.png";
// import motion
import { motion } from "framer-motion";
// import transition
import { transition1 } from "../transitions";
// cursor context
import { CursorContext } from "../context/CursorContext";
import { ImDownload3 } from "react-icons/im";
// Import Resume
import resume from "../img/home/Resume_final.pdf";

const Home = () => {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(CursorContext);
  return (
    <motion.section
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={transition1}
      className="section"
    >
      <div className="container mx-auto h-full relative">
        {/* text & img wrapper */}
        <div className="flex flex-col justify-center">
          {/* text */}
          <motion.div
            initial={{ opacity: 0, y: "-50%" }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: "-50%" }}
            transition={transition1}
            onMouseEnter={mouseEnterHandler}
            onMouseLeave={mouseLeaveHandler}
            className="w-full pt-36 pb-14 lg:pt-0 lg:pb-0 lg:w-auto z-10 lg:absolute flex flex-col justify-center items-center lg:items-start"
          >
            <h1 className="h1">
              Ankit <br /> Akash
            </h1>
            <p className="text-[26px] lg:text-[36px] font-primary mb-4 lg:mb-12">
              B.E Computer Science
            </p>

            <p className="text-[20px] lg:text-[25px] font-primary mb-4 lg:mb-15 ">
              <b>C++</b>&nbsp; <b>ReactJS</b>&nbsp; <b>SQL</b>&nbsp; <b>PHP</b>
              &nbsp; <b>Figma</b>&nbsp; <b>Canva</b>
            </p>
            <br />
            {/*resume button*/}
            <a href={resume} download="Resume">
              <div className="btn mb-[30px] justify-center ">
                Resume &nbsp;
                <ImDownload3 />
              </div>
            </a>
          </motion.div>
          {/* image */}
          <div className="flex justify-end max-h-96 lg:max-h-max">
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0 }}
              transition={transition1}
              className="relative lg:-right-20 overflow-hidden"
            >
              <motion.img
                whileHover={{ scale: 1.09 }}
                transition={transition1}
                src={MyImg}
                alt="Profile"
                className=""
              />
            </motion.div>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default Home;
